// shared.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { apiUrls, OEMUrls } from '../utils/apiUrls';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  private selectedComponentSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  apiUrl = apiUrls.notifications;
  apiContactUsUrl = apiUrls.contactus;
  onboarding = apiUrls.onboarding;
  masterdata = apiUrls.masterdata;
  constructor(private http: HttpClient) {}

  getNotifications(userId?: string, pageNumber?: number, pageSize?: number, status?: string): Observable<any> {
    const url = `${this.apiUrl}?userid=${userId}&pageNumber=${pageNumber || 0}&pageSize=${pageSize || 10}&status=${status}`;
    return this.http.get<any>(url);
  }

  changeAllNotifications(path: string, status: string){
    const url = `${this.onboarding}/update/list?${path}&status=${status}`;
    return this.http.put<any>(url,'')
  }

  updateStatus(id: string, status: string): Observable<Observable<Event>> {
    const params = new HttpParams()
      .set('id', id)
      .set('status', status);
    return this.http.put<Observable<Event>>(`${this.onboarding}/update`, null, { params });
  }
  setSelectedComponent(component: string): void {
    this.selectedComponentSubject.next(component);
  }

  getSelectedComponent(): Observable<string> {
    return this.selectedComponentSubject.asObservable();
  }

  saveContactUs(data: any): Observable<string> {
    return this.http.post<any>(this.apiContactUsUrl, data);
  }

  saveTicket(data: any) {
    return this.http.post<any>(`${this.onboarding}/ticket`, data);
  }

  getTickets() {
    return this.http.get<any>(`${this.onboarding}/ticket?pageNumber=0&pageSize=100`);
  }

  deleteTicket(id: string) {
    return this.http.delete<any>(`${this.onboarding}/ticket/${id}`);
  }

  ticketById(id: string) {
    return this.http.get<any>(`${this.onboarding}/ticket/${id}`);
  }

  getTicketsByCreatedById(id:any) {
    return this.http.get<any>(`${this.onboarding}/ticket/created-by-id/${id}?pageNumber=0&pageSize=10`);
  }
  
  getAssignedTicketsByUserId(id:any) {
    return this.http.get<any>(`${this.onboarding}/ticket/assigned/${id}?pageNumber=0&pageSize=10`);
  }

  updateTicket(id: string, data: any) {
    return this.http.put<any>(`${this.onboarding}/ticket/${id}`, data);
  }

  getCommentsByTicketId(ticketId:string) {
    return this.http.get<any>(`${this.onboarding}/comments/ticket/${ticketId}`);
  }

  deleteComment(id:string) {
    return this.http.delete<any>(`${this.onboarding}/comments/${id}`);
  }

  addComments(comment: any) {
    return this.http.post<any>(`${this.onboarding}/comments`, comment);
  }

  editComment(id: string, comment: any) {
    return this.http.put<any>(`${this.onboarding}/comments/${id}`, comment);
  }

  issueRelated() {
    return this.http.get<any>(`${this.masterdata}/issue-related/all?pageNumber=0&pageSize=10`);
  }

  priortyLevel() {
    return this.http.get<any>(`${this.masterdata}/priority-level/all?pageNumber=0&pageSize=10`);
  }

  assignTo() {
    return this.http.get<any>(`${this.onboarding}/ticket/support-staff?pageNumber=0&pageSize=10`);
  }

  userDetailsSupportTicket(type: string, pageNumber: number, pageSize: number) {
    return this.http.get<any>(`${this.onboarding}/ticket/user-details?type=${type}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }

  private searchKeyword = new BehaviorSubject<string>('');
  private pageIndex = new BehaviorSubject<number>(0);
  private pageSize = new BehaviorSubject<number>(10);
  
  currentSearchKeyword$ = this.searchKeyword.asObservable();
  currentPageIndex$ = this.pageIndex.asObservable();
  currentPageSize$ = this.pageSize.asObservable();

  setSearchState(keyword: string, pageIndex: number = 0, pageSize: number = 10) {
    this.searchKeyword.next(keyword);
    this.pageIndex.next(pageIndex);
    this.pageSize.next(pageSize);
  }

  clearSearchState() {
    this.searchKeyword.next('');
    this.pageIndex.next(0);
    this.pageSize.next(10);
  }

  getCurrentState() {
    return {
      keyword: this.searchKeyword.value,
      pageIndex: this.pageIndex.value,
      pageSize: this.pageSize.value
    };
  }

  getExhibitionCompanynames() {
    return this.http.get<any>(`${this.onboarding}/exhibition/company-names`);
  }

}
